import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "./../../environments/environment";
import { ProspectService } from "./prospect-service.service";
import { Injectable } from "@angular/core";
import { map, shareReplay } from "rxjs";
import brandInfo from "../../environments/brand.json";

import { ActivatedRouteSnapshot, ActivatedRoute } from "@angular/router";
import { Vehicle } from "../_models/vehicle";
import { Store } from "@ngrx/store";
import { EMPTY,  lastValueFrom, from, Observable, of } from "rxjs";
import Prismic from "prismic-javascript";
import { prismicContent } from "../_models/prismic";



import { PrismicService } from "./prismic.service";

import { catchError } from "rxjs";
import { MDBModalService } from "ng-uikit-pro-standard";
import { ModalTechnicalDifficultyComponent } from "../modal-technical-difficulty-error/modal-technical-difficulty-error.component";

@Injectable({
  providedIn: "root",
})
export class HomeService {
  vehicle$: Observable<Vehicle>;
  footerCache = null;

  constructor(
    private modalService: MDBModalService,
    private prospectService: ProspectService,
    private httpClient: HttpClient,
    private prismicService: PrismicService,
    private route: ActivatedRoute,
    private store: Store<{
      vehicle: Vehicle;
    }>
  ) {
    this.modalService = modalService;
  }

  createSlices(typesArray, prismicData, uniqueSlicesArray) {
    const slices = [];
    console.log("e. createSlices from orderData: ", { typesArray, prismicData, uniqueSlicesArray });

    for (let i = 0; i < typesArray.length; i++) {
      const element = typesArray[i];

      // Get index of the prismic data
      const queryIndex = uniqueSlicesArray.indexOf(typesArray[i]);
      if(prismicData[queryIndex].data.page) {
        slices.push(prismicData[queryIndex].data.page.body[i]);
      }
    }

    return slices;
  }

  async getLeadInformation(brand, prid) {
    const leadRequestData = {
      payload: {
        prid: prid,
        brand: brand,
      },
    };
    let leadResponse;

    try {
      leadResponse = await  lastValueFrom(this.prospectService.get_accountContact(leadRequestData));
    } catch (err) {
      console.error("getLeadInformation Error: ", err);
      leadResponse = {
        vehicle: {
          isElectric: false,
        },
      };
    }

    return leadResponse;
  }

  async getTags(tags: Array<string>, route) {
    console.log("Getting tags.", tags);

    let vehicle;

    // Get Vehicle From Store
    // let vehicle = await this.store.select((store) => store.vehicle).toPromise()

    // If vehicle does not exist in store, try to get from Session Storage.
    if (!vehicle) {
      vehicle = JSON.parse(sessionStorage.getItem("vehicle"));
      console.log("Getting vehicle from Session Storage...", vehicle);
    } else {
      console.log("Got vehicle from store");
    }

    // If vehicle does not exists in store or session storage, try to get from Account api.
    if (!vehicle) {
      if (route.queryParams.prid) {
        let leadResponse = await this.getLeadInformation(brandInfo.brand, route.queryParams.prid);
        vehicle = leadResponse.vehicle;
        console.log("Getting vehicle from API...", vehicle);
      }
    }

    if (vehicle) {
      console.log("vehicle: ", vehicle);

      tags = vehicle.isElectric ? [...tags, "electric"] : [...tags, "non-electric"];
      console.log("tags: ", tags);
    } else {
      // This should only be if no vehicle.
      console.log("This should only be called if no vehicle object in store, session storage, or from account api. Defaulting to non-electric. ");
      tags = [...tags];
    }

    return tags;
  }

  async resolvePage(route: ActivatedRouteSnapshot) {
    // Get query Params
    // const brand: string = route.queryParams.brand || "REV";

    console.log("Route info: ", route);

    const pageType: string = route.data.pageType ? route.data.pageType : "home";
    const lang: string = route.data.lang ? route.data.lang : "en-us";
    const productType: string = route.data.productType ? route.data.productType : "";
    let tags = await this.getTags([productType, pageType, brandInfo.brand], route);

    return this.queryAll(tags, lang);
  }

  getPage(params) {
    const _vehicle = JSON.parse(sessionStorage.getItem("vehicle"));
    console.log("%c ***** home.service.ts ******", "color: #188977");

    console.log("a. getPage: ", params);

    let lang = sessionStorage.getItem("preferredLanguage") ? sessionStorage.getItem("preferredLanguage") : brandInfo.language;

    if (params.pageId) {
      console.log("b. Get prismic page by page id");
      return this.getPageById(params.pageId, lang);
    } else if (params.pageurl) {
      // Check for electric
      let pageurl = params.pageurl;

      if (
        params.isElectric === "electric" &&
        !!brandInfo.homePageElectric &&
        params.pageurl === brandInfo.homePage
      ) {
        pageurl = brandInfo.homePageElectric;
      }

      // if ((brandInfo.brand === 'HPP' || brandInfo.brand === 'Genesis') && _vehicle && _vehicle.isElectric && sessionStorage.getItem('page') === 'ratesPage') {
      //   pageurl = 'electric-plans-pricing'
      // }

      console.log("b. Get prismic page by page id");
      return this.getPageByUrl(pageurl, params.parenturl, brandInfo.brand, lang);
    } else {
      console.log("b. Get prismic page by tags");
      return this.getPageByTags(params);
    }
  }

  getPageByTags(params) {
    console.log("getPageByTags: ", params);

    const pageType: string = params.pageType ? params.pageType : "home";
    const lang: string = params.lang ? params.lang : "en-us";
    const product: string = params.product ? params.product : "";
    const electricTag = params.isElectric === "electric" || params.isElectric === "non-electric" ? params.isElectric : "";
    let tags = [product, pageType, brandInfo.brand, electricTag];
    tags = tags.filter((tag) => tag !== "");
    let content = from(this.queryAll(tags, lang));
    console.log("%c ***********", "color: #188977");
    return content;
  }

  getPageById(pageId: string, lang: string) {
    console.log("getPageById: ", pageId);
    let content = from(this.queryAllByPageId(pageId, lang));
    // let content = from(this.getPageByUid(pageId, lang));

    console.log("%c ***********", "color: #188977", content);
    return content;
  }

  getPageByUrl(pageurl: string, parenturl: string, brand: string, lang: string) {
    console.log("getPageByUrl: ", parenturl, pageurl);
    let content = from(this.queryAllByPageUrl(pageurl, parenturl, brand, lang));
    // let content = from(this.getPageByUid(pageId, lang));

    console.log("%c ***********", "color: #188977", content);
    return content;
  }

  private isValidOrderData(orderData: any): boolean {
    return !!(orderData && orderData._meta && orderData._meta.uid && Array.isArray(orderData.body));
  }

  async queryAllByPageUrl(pageurl: string, parenturl: string, brand: string, lang: string) {
    console.log(`Querying Prismic slices based on url ${pageurl}`);

    let orderData = await this.getOrderByPageUrl(pageurl, parenturl, brand, lang);

    // If electric homepage content is missing, retry the configured non-electric homepage.
    if (
      !this.isValidOrderData(orderData) &&
      !!brandInfo.homePageElectric &&
      !!brandInfo.homePage &&
      pageurl === brandInfo.homePageElectric &&
      brandInfo.homePageElectric !== brandInfo.homePage
    ) {
      orderData = await this.getOrderByPageUrl(brandInfo.homePage, parenturl, brand, lang);
    }

    // If No page exists, gracefully exit
    if (!this.isValidOrderData(orderData)) {
      console.log(`No Prismic data found that matches pageurl ${pageurl}`);
      return [];
    }

    console.log(`orderData:`, orderData);

    return this.getSlices(orderData, lang);
  }

  async queryAllByPageId(pageId: string, lang: string) {
    console.log(`c. Querying Prismic slices based on id ${pageId}`);

    const orderData = await this.getOrderByPageId(pageId, lang);

    // If No page exists, gracefully exit
    if (!this.isValidOrderData(orderData)) {
      console.log(`d. No Prismic data found that matches pageId ${pageId}`);
      return [];
    }

    console.log(`d. orderData:`, orderData);

    return this.getSlices(orderData, lang);
  }

  async queryAll(tags: string[], lang: string) {
    console.log(tags);
    console.log(`Querying Prismic slices based on tags ${tags}`);

    let orderData = await this.getOrderByTag(tags, lang);

    // Some tenants don't have electric/non-electric tag variants for home pages.
    // Retry without that tag before giving up.
    if (!this.isValidOrderData(orderData)) {
      const fallbackTags = tags.filter((tag) => tag !== "electric" && tag !== "non-electric");
      if (fallbackTags.length !== tags.length) {
        orderData = await this.getOrderByTag(fallbackTags, lang);
      }
    }

    // If No page exists, gracefully exit
    if (!this.isValidOrderData(orderData)) {
      console.log(`No Prismic data found that matches tag ${tags}`);
      return [];
    }

    return this.getSlices(orderData, lang);
  }

  async getSlices(orderData, lang) {
    // Get set of group request
    const prismicSlices = orderData.body;
    const uid = orderData._meta.uid;

    // Get page meta data
    const pageMeta = {
      meta_title: orderData.meta_title,
      meta_description: orderData.meta_description,
      robots: orderData.robots,
      sticky_header: orderData.sticky_header,
    };

    // Set Sticky Header
    if(pageMeta && pageMeta.sticky_header === false){
      window.sessionStorage.setItem('stickyHeader', 'false')
      let navbar = document.getElementById("navbar") as HTMLElement;
      navbar.classList.remove("fixed-top");
      let mainContent = document.getElementById("mainContent") as HTMLElement;
      mainContent.classList.remove("offset");
    }

    // Get class name assigned to page
    const pageClass = orderData.class_name;

    // console.log("pageMeta: ", pageMeta)

    // get distinct slices
    const typesArray = prismicSlices.filter((element) => !!element.type).map((element) => element.type);
    const uniqueSlicesArray = [...new Set(typesArray)];

    console.log(`Querying slices content for ${uid}`);

    // Create Array of promises
    const promises = [];
    for (const type of uniqueSlicesArray) {
      switch (type) {
        // case "header":
        //   promises.push(this.getHeader(uid, lang));
        //   break;
        case "hero":
          promises.push(this.getHero(uid, lang));
          break;
        case "content_block":
          promises.push(this.getContentBlocks(uid, lang));
          break;
        case "plans":
          promises.push(this.getPlans(uid, lang));
          break;
        case "faq":
          promises.push(this.getFAQ(uid, lang));
          break;
        case "seo":
          promises.push(this.getSEO(uid, lang));
          break;
        case "product":
          promises.push(this.getProduct(uid, lang));
          break;
        case "products_tabset":
          promises.push(this.getProductTabset(uid, lang));
          break;
        case "title":
          promises.push(this.getTitle(uid, lang));
          break;
        case "text":
          promises.push(this.getText(uid, lang));
          break;
        case "image":
          promises.push(this.getImage(uid, lang));
          break;
        case "support_page":
          promises.push(this.getSupportPage(uid, lang));
          break;
        default:
          break;
      }
    }

    // Perform all promises at once
    const prismicData = await Promise.all(promises);

    const slices = this.createSlices(typesArray, prismicData, uniqueSlicesArray);
    // console.log("queryAll - Got slices: ", slices);

    let pageData: prismicContent = { content: slices, pageMeta: pageMeta, pageClass: pageClass };

    return pageData;
  }

  getBranding(brand, lang) {
    const headers = this.getPrismicRefHeaders();

    return this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/brands`, {
        params: {
          brand: brand,
          lang: lang
        },
        headers: headers,
      })
      .pipe(
        catchError((error) => {
          this.modalService.show(ModalTechnicalDifficultyComponent, { class: "modal-dialog-centered" });
          return error;
        }),
        map((result) => {
          // console.log("getBranding: ", result.data.allBrandings.edges[0].node);
          console.log('result.data.allBrandings.edges[0]: ',result.data.allBrandings.edges[0])
          if (result.data.allBrandings.edges[0] !== undefined) {
            return result.data.allBrandings.edges[0].node;
          } else {
            return this.getBackupBranding(brand);
          }
        })
      );
  }

  getBackupBranding(brand) {
    const headers = this.getPrismicRefHeaders();
    return this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/brands`, {
        params: {
          brand: brand,
          lang: 'en-us' // Load 'en-us' in case the registered language isn't accounted for
        },
        headers: headers,
      })
      .pipe(
        catchError((error) => {
          this.modalService.show(ModalTechnicalDifficultyComponent, { class: "modal-dialog-centered" });
          return error;
        }),
        map((result) => {
          // console.log("getBranding: ", result.data.allBrandings.edges[0].node);
          console.log('result.data.allBrandings.edges[0]: ',result.data.allBrandings.edges[0])
          return result.data.allBrandings.edges[0].node;
        })
      );
  }

  getOrderByPageUrl(pageurl: string, parenturl: string, brand: string, lang: string): any {
    const headers = this.getPrismicRefHeaders();


    //OrderByPageUrl - electric-plans-pricing

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/page/orderByPageUrl`, {
        params: {
          pageurl: pageurl.toLowerCase(),
          parenturl: parenturl ? parenturl : "",
          brand,
          lang: lang,
        },
        headers: headers,
      }))
  }

  getOrderByUid(uid: string, lang: string): any {
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/page/orderByUid`, {
        params: {
          uid: uid,
          lang: lang,
        },
        headers: headers,
      }))
  }

  getOrderByTag(tags: string[], lang: string): any {
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/page/orderByTag`, {
        params: {
          tags: tags,
          lang: lang,
        },
        headers: headers,
      }));
  }

  getOrderByPageId(pageId: string, lang: string): any {
    console.log("getOrderByPageId");
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/page/orderByPageId`, {
        params: {
          pageId: pageId,
          lang: lang,
        },
        headers: headers,
      }))
  }

  getHeader(brand: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/header`, {
        params: {
          brand: brand,
          lang: lang,
        },
        headers: headers,
      })
      .pipe(map((result) => result.data.allHeaders.edges[0].node));
  }

  getFooter(brand: string, lang: string): Observable<any> {
    if(this.footerCache) {
      return this.footerCache;
    } else {
    const headers = this.getPrismicRefHeaders();
    return this.footerCache = this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/footer`, {
        params: {
          brand: brand,
          lang: lang,
        },
        headers: headers,
      })
      .pipe(
      shareReplay(1),
      map((result) => result.data.allFooters.edges[0].node),
      catchError(err => {
          this.footerCache = null;
          return EMPTY;
      }));
    }
  }

  getHero(uid: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/slice/hero`, {
        params: {
          uid: uid,
          lang: lang,
        },
        headers: headers,
      }))
  }

  getProduct(uid: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/slice/product`, {
        params: {
          uid: uid,
          lang: lang,
        },
        headers: headers,
      }));
  }

  getProductTabset(uid: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/slice/producttabs`, {
        params: {
          uid: uid,
          lang: lang,
        },
        headers: headers,
      }))
  }

  getPlans(uid: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/slice/plans`, {
        params: {
          uid: uid,
          lang: lang,
        },
        headers: headers,
      }))
  }

  getTitle(uid: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/slice/title`, {
        params: {
          uid: uid,
          lang: lang,
        },
        headers: headers,
      }))
  }

  getText(uid: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/slice/text`, {
        params: {
          uid: uid,
          lang: lang,
        },
        headers: headers,
      }))
  }

  getImage(uid: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/slice/image`, {
        params: {
          uid: uid,
          lang: lang,
        },
        headers: headers,
      }))
  }

  getFAQ(uid: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/slice/faq`, {
        params: {
          uid: uid,
          lang: lang,
        },
        headers: headers,
      }))
  }

  getPageByUid(uid: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/page`, {
        params: {
          uid: uid,
          lang: lang,
        },
        headers: headers,
      }))
  }

  async getMasterToken() {
    const env = environment.production ? "prod" : "dev";
    const prismicEnv = await this.prismicService.getEnvironment(env);

    console.log("prismicEnv 3: ", prismicEnv);

    let apiData = await Prismic.api(prismicEnv.apiEndpoint, {
      accessToken: prismicEnv.accessToken,
    });
    const masterRef = apiData.refs.find((ref) => ref.isMasterRef === true);

    return masterRef.ref;
  }

  getPrismicRefHeaders() {

    const env = environment.production ? "prod" : "dev";
    let prismicEnv = this.prismicService.getEnvironment(env);

    // console.log("prismicEnv: ", prismicEnv);

    // Get Cookies - Created in PrismicService
    let prismicRef = localStorage.getItem("Prismic-ref") || "";
    let prismicBaseUrl = localStorage.getItem("Prismic-baseUrl") || prismicEnv.baseUrl;

    // Set Headers
    const httpHeaders = new HttpHeaders({
      "Prismic-ref": prismicRef,
      "Prismic-baseUrl": prismicBaseUrl,
    });

    return httpHeaders;
  }

  getContentBlocks(uid: string, lang: string) {
    // console.log("getContentBlocks", uid, lang);

    const headers = this.getPrismicRefHeaders();

    console.log("Prismic headers", headers);

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/contentblock`, {
        params: {
          uid: uid,
          lang: lang,
        },
        headers: headers,
      }))
  }

  getContentBlockByUid(uid: string) {
    console.log("getContentBlock By Id", uid);

    const headers = this.getPrismicRefHeaders();
    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/slice/contentblock/${uid}`, {
        headers: headers,
      }))
  }

  getSEO(uid: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/seo`, {
        params: {
          uid: uid,
          lang: lang,
        },
        headers: headers,
      }))
  }

  findPageAdvanced(searchText: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return this.httpClient.get<any>(`${environment.apiUrl}/v1/api/content/support-page/findAdvanced`, {
      params: {
        searchText: searchText,
        lang: lang,
      },
      headers: headers,
    });
  }

  findPage(searchText: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return  lastValueFrom(this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/support-page/findPage`, {
        params: {
          searchText: searchText,
          lang: lang,
        },
        headers: headers,
      }))
  }

  getAllSupportPages(lang: string) {
    const headers = this.getPrismicRefHeaders();

    return this.httpClient
      .get<any>(`${environment.apiUrl}/v1/api/content/support-page/all`, {
        params: {
          lang: lang,
        },
        headers: headers,
      })
      .pipe(map((result) => result.data));
  }

  getSupportPage(tags: string[], lang: string) {
    const headers = this.getPrismicRefHeaders();

    return this.httpClient.get<any>(`${environment.apiUrl}/v1/api/content/support-page`, {
      params: {
        tags: tags,
        lang: lang,
      },
      headers: headers,
    });
  }

  getSupportPageByUid(uid: string, lang: string) {
    const headers = this.getPrismicRefHeaders();

    return this.httpClient.get<any>(`${environment.apiUrl}/v1/api/content/support-page/${uid}`, {
      params: {
        lang: lang,
      },
      headers: headers,
    });
  }
}
